import { Chip, SxProps } from '@mui/material';
import { Button } from 'system/atoms';
import { useOrganizationConfig } from 'core/stores/hooks/useOrganizationConfig';
import { useTracking } from 'services/tracking/hooks';
import { TrackingEventName } from 'services/tracking/constants';
import { usePathsV2 } from 'core/services/navigation/usePathsV2';
import { ArrowForward } from '@mui/icons-material';
import { CandidateListTab } from 'modules/candidate-profile/stores/useCandidateListStore';

const magicButtonSx: SxProps = {
  width: 'fit-content'
};

const betaChipSx: SxProps = {
  fontSize: '12px'
};

type SourcingButtonProps = {
  candidateBatchId: string;
};

export const SourcingAnalyseDetailsButton: React.FC<SourcingButtonProps> = ({
  candidateBatchId
}) => {
  const organizationConfig = useOrganizationConfig();
  const { track } = useTracking();
  const { navigateToPath } = usePathsV2();

  const handleInternalSourcingClick = () => {
    track(TrackingEventName.AnalyseDashboardSourceFromMainCTA, {
      candidateBatchId
    });
    navigateToPath.ANALYSE_CANDIDATE_PROFILE_LIST({
      candidateBatchId,
      searchParams: { tab: CandidateListTab.CANDIDATES }
    });
  };

  const handleExternalSourcingClick = () => {
    track(TrackingEventName.AnalyseDashboardSourceFromMainCTA, {
      candidateBatchId
    });
    navigateToPath.ANALYSE_SOURCE_EXTERNAL_CANDIDATES({ candidateBatchId });
  };

  // Internal sourcing takes priority over external sourcing
  if (organizationConfig?.internalSourcingEnabled) {
    return (
      <Button
        sx={magicButtonSx}
        variant="tertiary"
        startIcon={<ArrowForward />}
        onClick={handleInternalSourcingClick}
      >
        Source more candidates
        <Chip label="BETA" color="primary" variant="inverse" sx={betaChipSx} />
      </Button>
    );
  }

  if (organizationConfig?.sourcingEnabled) {
    return (
      <Button
        sx={magicButtonSx}
        variant="tertiary"
        startIcon={<ArrowForward />}
        onClick={handleExternalSourcingClick}
      >
        Source more candidates
        <Chip label="BETA" color="primary" variant="inverse" sx={betaChipSx} />
      </Button>
    );
  }

  return null;
};
